<template>
  <v-card v-if="getNavbarItemsFeatures.length > 0">
    <v-layout>
      <v-navigation-drawer v-model="navigation.shown">

        <template #prepend>
          <v-list-item @click="goTo('/home/dashboard')" class="text-center">
            <div class="text-center" v-if="getCurrentCompany != null">
              <div style="width: 220px; height: 40px;">
                <img
                    :src="getCurrentCompany.logo_thumb ? getFileServerUrl + getCurrentCompany.logo_thumb : '@/assets/image/logo.png'"
                    class="logo2"
                    style="max-width: 220px; max-height: 40px;" />
              </div>
            </div>
          </v-list-item>

          <v-list-item @click="goTo('/home/dashboard')" class="text-center bg-primary">
            {{ currentModuleName }}
          </v-list-item>
        </template>


        <v-list  density="compact" nav>
          <template v-for="item in getNavbarItemsFeatures">
          <v-list-group :value="item.name" v-if="item.menu.length > 0">
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                :prepend-icon="item.icon"
                :title="item.name"
              ></v-list-item>
            </template>
              <template v-for="(child, i) in item.menu" >
                <router-link :to="child.link" class="text-decoration-none text-black" style="background-color: #B4B5B6 !important;">
                    <v-list-item
                      :key="i"
                      :value="child.name"
                      :title="child.name"
                      :prepend-icon="child.icon"
                      color="blue-darken-3"
                      :active="activeMenuItem === child.link"
                      @click="unSelectButton(item.name, child.name, child.link)"
                      style="padding-inline-start: 20px !important;"
                      >
                    </v-list-item>
                </router-link>
              </template>
          </v-list-group>
        </template>
        </v-list>
      </v-navigation-drawer>

      <v-main style="height: 100vh"></v-main>
    </v-layout>
  </v-card>
</template>
<script>
  export default {
    props: ["navigation"],
    data: () => ({
        toggle: "Dashboard",
        navigation: {
          shown: false,
        },
        activeMenuItem: null
    }),

    created (){

    },
    watch: {
      '$route.fullPath': {
          immediate: true,
          handler() {
              const to = this.$route;
              this.getNavbarItemsFeatures.forEach(item => {
                item.menu?.forEach(child => {
                  if (this.normalizeModulePath(child.link?.split('?')[0]) === this.normalizeModulePath(to.path)) {
                      this.activeMenuItem = child.link;
                      this.toggle = item.name;
                  }
                });
              });
          }
      },
  },
    computed: {
      getNavbarItems(){
        return this.$store.getters.getNavbarItems
      },
      getCurrentCompany() {
        return this.$store.getters.getCurrentCompany;
      },
      getNavbarItemsFeatures() {
        const menu = this.parseMenu();
        const aliases = this.routePrefixAliases;
        let currentModule = menu.find(item => aliases.includes(String(item?.prefix || '').toLowerCase()));

        if (!currentModule) {
          const routePath = this.$route.path;
          currentModule = menu.find(item => (item.sub_module || []).some(subModule =>
            (subModule.menu || []).some(child => this.normalizeModulePath(child.link?.split('?')[0]) === this.normalizeModulePath(routePath))
          ));
        }

        return currentModule?.sub_module || [];
      },
      currentModuleName() {
        const menu = this.parseMenu();
        const aliases = this.routePrefixAliases;
        const currentModule = menu.find(item => aliases.includes(String(item?.prefix || '').toLowerCase()))
          || menu.find(item => (item.sub_module || []).some(subModule =>
            (subModule.menu || []).some(child => this.normalizeModulePath(child.link?.split('?')[0]) === this.normalizeModulePath(this.$route.path))
          ));

        return currentModule?.name || '';
      },
      routePrefixAliases() {
        const firstSegment = this.$route.path.split('/')[1]?.toLowerCase() || '';
        const routePrefix = firstSegment === 'module'
          ? this.$route.path.split('/')[2]?.toLowerCase() || ''
          : firstSegment;
        const configuredPrefix = String(this.$route.meta?.modulePrefix || '').toLowerCase();
        const configuredAliases = this.$route.meta?.modulePrefixAliases || [];

        return [...new Set([
          routePrefix,
          configuredPrefix,
          ...configuredAliases.map(alias => String(alias).toLowerCase()),
        ].filter(Boolean))];
      },
      getFileServerUrl() {
          return this.$store.getters.getFileServerUrl;
      },
  },
    methods:{
      parseMenu() {
        try {
          const menu = JSON.parse(localStorage.getItem("menu") || "[]");
          return Array.isArray(menu) ? menu : [];
        } catch (_) {
          return [];
        }
      },
      normalizeModulePath(path) {
        const cleanPath = String(path || '');
        return cleanPath === '/prd' || cleanPath.startsWith('/prd/')
          ? cleanPath.replace(/^\/prd(?=\/|$)/, '/production')
          : cleanPath;
      },
      goTo(val) {
        this.$router.push({ path: val }).catch(err => {});
      },
      unSelectButton(parentName, childName, childLink){
        this.toggle = parentName;
        this.activeMenuItem = childLink;
      }
    },
  }
</script>

